import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

// Stable CTA renderer — defined outside the parent so React can preserve its
// type across re-renders (avoids react/no-unstable-nested-components).
function Cta({ ctaLabel, testid, withOnClick = false, onClick }) {
  return (
    <Button
      size="lg"
      className="text-sm md:text-base whitespace-nowrap"
      data-testid={testid ? `${testid}-cta` : undefined}
      onClick={withOnClick ? onClick : undefined}
    >
      {ctaLabel} <ArrowRight className="w-4 h-4 ml-1.5" />
    </Button>
  );
}

// Reusable mid-page conversion banner.
// Props: eyebrow, title, body, ctaLabel, to (route) | href (anchor or external) | onClick, variant
export default function ConversionBanner({
  eyebrow,
  title,
  body,
  ctaLabel = 'Inizia ora',
  to,
  href,
  onClick,
  variant = 'gold',
  testid,
}) {
  const palette = {
    gold: 'from-[var(--gp-gold)]/15 to-[var(--gp-gold-soft)]/15 border-[var(--gp-gold)]/40',
    teal: 'from-[var(--gp-teal)]/15 to-[var(--gp-emerald-2)]/15 border-[var(--gp-teal)]/40',
    emerald: 'from-[var(--gp-emerald-2)]/15 to-[hsl(var(--primary))]/10 border-[hsl(var(--primary))]/30',
  }[variant] || '';

  return (
    <section className="px-4 md:px-12 py-8 md:py-12" data-testid={testid}>
      <div className={`max-w-5xl mx-auto rounded-2xl border bg-gradient-to-br p-5 md:p-8 ${palette}`}>
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-6">
          <div className="flex-1">
            {eyebrow && <div className="text-[10px] md:text-xs tracking-[0.3em] uppercase text-[var(--gp-gold)]">{eyebrow}</div>}
            <h3 className="font-serif text-xl md:text-3xl text-[hsl(var(--primary))] mt-1 leading-tight">{title}</h3>
            {body && <p className="text-xs md:text-sm text-muted-foreground mt-2 max-w-2xl">{body}</p>}
          </div>
          <div className="shrink-0">
            {to ? <Link to={to}><Cta ctaLabel={ctaLabel} testid={testid} /></Link>
              : href ? <a href={href}><Cta ctaLabel={ctaLabel} testid={testid} /></a>
              : <Cta ctaLabel={ctaLabel} testid={testid} withOnClick onClick={onClick} />}
          </div>
        </div>
      </div>
    </section>
  );
}
